import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative flex flex-col items-center justify-center px-4 sm:px-6 overflow-hidden pt-32 sm:pt-40 md:pt-48 pb-20 sm:pb-32 md:pb-40" data-id="element-55">
      <div className="z-10 flex flex-col items-center text-center w-full max-w-4xl" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.0,
        ease: 'easeOut'
      }} className="mb-2 sm:mb-4 md:mb-6 flex justify-center w-full" data-id="element-57">
          <img src="https://cdn.magicpatterns.com/uploads/e9nC2XUWqjWVpEamds9i4m/ChatGPT_Image_May_2,_2026,_05_12_05_PM.png" alt="Pollock Ventures" className="w-[420px] sm:w-[640px] md:w-[860px] lg:w-[1040px] h-auto select-none" data-id="element-58" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-59">
          <p className="font-heading text-2xl sm:text-3xl md:text-5xl text-brand-offWhite mb-12 sm:mb-16 font-extralight tracking-tight" data-id="element-60">
            Investing in what's next.
          </p>

          {/* Vertical line visual cue */}
          <motion.div className="w-px h-20 sm:h-32 bg-gradient-to-b from-brand-gold/60 to-transparent" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} transition={{
          duration: 1.0,
          delay: 1.4,
          ease: 'easeInOut'
        }} data-id="element-61" />
        </motion.div>
      </div>
    </section>;
}